import { BASE_API_URL } from 'api/config';
import { createAxios } from './axios';

const rolesApi = createAxios({
    baseURL: BASE_API_URL + '/role'
});

export const getRoleConfig = () => {
    return rolesApi.get('/config');
};